//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            index: 0,
            showIntro: true,
            showPurchasedScreen: false
        };
    },

    computed: {
        stars () {
            return this.$store.getters.stars;
        },
        spaceships () {
            return this.$store.getters.spaceships;
        },
        activeSpaceship () {
            return this.spaceships[this.index];
        },
        previousSpaceship () {
            return (this.index > 0) ? this.spaceships[this.index - 1] : undefined;
        },
        nextSpaceship () {
            return (this.index < this.spaceships.length - 1) ? this.spaceships[this.index + 1] : undefined;
        }
    },

    watch: {
        index () {
            this.showIntro = false;
        }
    },

    methods: {
        buy () {
            axios.post('game/spaceship', {
                name: this.activeSpaceship.name,
                spend_stars: this.activeSpaceship.price
            }).then(response => {
                this.$store.commit('storeGameData', response.data.data);
                this.showPurchasedScreen = true;
            }).catch(() => {});
        },
        setSpaceship () {
            axios.post('game/spaceship/set', {
                name: this.activeSpaceship.name
            }).then(response => {
                this.$store.commit('storeGameData', response.data.data);
            }).catch(() => {});
        }
    }
};
